// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading[data-v-1cde4fa4]{display:grid;grid-template-columns:1fr 32px;padding:0 15px;margin-bottom:10px}.title[data-v-1cde4fa4]{font-weight:700;font-size:1.2em}", ""]);
// Exports
module.exports = exports;
